import {ElementValidatorUtil} from "./ElementValidatorUtil";
import {DOM} from "../DOM";

/**
 * Check the select element and validate it
 * Use the validation options appended to select elements
 */
export class SelectValidator {

    public static validateSelect(select: HTMLSelectElement) : void {

        const params = ElementValidatorUtil.getValidationParams(select);
        if (params.filled) { this.validateSelectFilled(select, params.filled); }
        if (params.revalidate) { this.processRevalidate(params.revalidate); }
    }


    /**
     * Validate FILLED function
     * Check if select is with value
     * @param element - select element
     * @param params
     * @private
     */
    private static validateSelectFilled(element: HTMLSelectElement, params: {filled: boolean, problem: string|null}) {

        const value = element.value.trim();
        if (value.toString().length < 1) {
            element.dataset.valid = "false";
            const parentElement = element.parentElement;
            if (parentElement?.classList.contains('select-wrapper')) { parentElement.dataset.valid = "false"; }
            ElementValidatorUtil.updateHelpElement(element, params.problem, false);
            return;
        }

        ElementValidatorUtil.updateHelpElement(element, params.problem, true);
    }

    /**
     * Validate PATTERN function
     * Check if value is correct for used pattern
     * @param params - check params
     */
    private static processRevalidate(params: {nameList: string[]}) {

        const event = new Event("change");
        for (const elementName of params.nameList) {
            const element = DOM.Parser.getHtmlInputElementByName(elementName);
            element.dispatchEvent(event);
        }
    }
}


